<template>
  <div class="lp-footer">
    <div class="footer container">
      <div class="columns" style="margin:0">
        <div class="column is-3-desktop">
          <div class="lp-title">서비스 이용</div>
          <div class="lp-cont">
            <a href="https://launchpack.co.kr/cs?menu=faq" target="_blank">FAQ</a>
          </div>
          <div class="lp-cont">
            <a href="https://launchpack.co.kr/cs?menu=notice" target="_blank">새소식</a>
          </div>
          <!--<div class="lp-cont unselect" @click="$router.push('launchpack/inquiry/customer')"><a>1:1 문의</a></div>-->
        </div>
        <div class="column is-3-desktop">
          <div class="lp-title">서비스 정책</div>
          <div class="lp-cont">
            <a href="https://launchpack.co.kr/term" target="_blank">서비스 이용약관</a>
          </div>
          <div class="lp-cont">
            <a href="https://launchpack.co.kr/limit" target="_blank">개인정보보호 정책</a>
          </div>
        </div>
        <div class="column is-3-desktop">
          <div class="lp-title">제휴</div>
          <div class="lp-cont">
            <a href="mailto:support@launchpack.co.kr">제휴 제안</a>
          </div>
        </div>
        <div class="column is-3-desktop">
          <div class="lp-title">기업정보</div>
          <div class="lp-cont">주식회사 런치팩</div>
          <div class="lp-cont">광주본사 : 광주광역시 동구 서남로 14 410호</div>
          <div class="lp-cont">서울지사 : 서울특별시 강남구 역삼로 175 4층 B호</div>
          <div class="lp-cont">
            <a href="mailto:support@launchpack.co.kr">이메일 : support@launchpack.co.kr</a>
          </div>
          <div class="lp-cont">
            <a href="tel:1544-9247">전화 : 1544-9247</a>
          </div>
          <div class="lp-cont">사업자등록번호 : 694-87-01163</div>
          <div class="lp-cont">통신판매업신고 : 제 2018-광주동구-0192 호</div>
          <div class="lp-cont">대표자 : 염민지 | 개인정보책임자 : 이남호</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {

  }
</script>
<style lang="stylus" type="stylus" scoped>
  .lp-footer .footer
    /*background-color: rgb(51, 51, 51);*/
    background-color: #292c32;
    color: white;
    clear:both;
    width: 100%;
    max-width: 100%;


  .lp-footer
    width:100%;
    //position: absolute;
    //left: 0;
    //bottom: 0;


  .footer
    padding-bottom: 3rem;
    margin: 0;




  .lp-title
    color: #a0a0a0;
    margin-bottom: 1.3rem;


  .lp-cont
    color: white;
    font-size: 0.9rem;
    margin-bottom: 8px;

  a
    color: white;
    cursor: pointer;


  a:hover
    color: #cccccc;

  @media(max-width:768px)
    .lp-footer
      border-top:none;



  .column
    padding: 0;


</style>
